import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function () {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const loginData = JSON.parse(localStorage.getItem("loginData"));

  const publicRoutes = [
    "/authentication/sign-in",
    "/authentication/forgot-password",
    "/authentication/forgot-password",
    "/authentication/reset-password",
    "/reset-password/:id",
    "/"
  ];

  React.useEffect(() => {
    const isAuthenticated = loginData?.token ? true : false;
    const isPublicRoute = publicRoutes.some((route) => {
      if (route.includes(":")) {
        const base = route.split("/:")[0];
        return pathname.startsWith(base + "/");
      }
      return route === pathname;
    });

    if (isAuthenticated && isPublicRoute) {
      navigate("/dashboard");
    } else if (!isAuthenticated && !isPublicRoute) {
      navigate("/authentication/sign-in");
    }
  }, [pathname, navigate, loginData?.token]);
}
